(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ap-walkthrough-body"] && !Shopify.designMode) return;
  try {
    (() => {
    // YouTube's player script, loaded only when someone presses play (keeps the page fast)
    let ytApi = null;
    const loadYouTube = () =>
      (ytApi ||= new Promise((resolve) => {
        if (window.YT && window.YT.Player) return resolve();
        const before = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          if (before) before();
          resolve();
        };
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }));

    const init = (root) => {
      if (root.dataset.apReady) return;
      root.dataset.apReady = '1';
      const id = root.dataset.video;
      const player = root.querySelector('.ap-walk__player');
      // yt is set once the player is ready; until then a tapped sound waits in `pending`
      let yt = null;
      let pending = null;
      // the video in the player – on the big bundles the row of videos under the player switches it
      let videoId = id;
      // Connect to the YouTube player already on the page (once): for the chapter buttons, the row of videos and
      // pausing other sounds. Its own play button works without this.
      let attaching = null;
      const attach = () =>
        (attaching ||= loadYouTube().then(
          () =>
            new Promise((resolve) => {
              const frame = player.querySelector('iframe');
              // a chapter tapped before the lazy player has loaded: load it now
              frame.loading = 'eager';
              new window.YT.Player(frame, {
                events: {
                  onReady: (ev) => {
                    yt = ev.target;
                    resolve(yt);
                  },
                  // started from YouTube's own play button: stop any demo that is playing
                  onStateChange: (ev) => {
                    if (ev.data === 1) document.dispatchEvent(new CustomEvent('ap:play', { detail: root }));
                  },
                },
              });
            })
        ));
      const play = (start) => {
        // Pause any demo that is playing.
        document.dispatchEvent(new CustomEvent('ap:play', { detail: root }));
        if (yt) {
          // jump inside the same video – no reload, much faster on phones
          yt.seekTo(start, true);
          yt.playVideo();
        } else {
          // first tap: connect, then play the sound tapped last
          const first = pending === null;
          pending = start;
          if (first) {
            attach().then((p) => {
              if (p.getVideoData?.().video_id !== videoId) p.loadVideoById(videoId, pending);
              else {
                p.seekTo(pending, true);
                p.playVideo();
              }
            });
          }
        }
        root.classList.add('is-started');
      };
      // connect to the player just before it scrolls into view – only with cookie consent
      // (Consentmo answers through Shopify's customer privacy API)
      if (id && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            // 'yes' only once the visitor has accepted – not just allowed by default before they answered
            if (window.Shopify?.customerPrivacy?.currentVisitorConsent?.().marketing !== 'yes') return;
            io.disconnect();
            attach();
          },
          { rootMargin: '600px 0px' }
        );
        io.observe(root);
      }
      // only one sound on the page at a time: pause the video when a demo or a card starts playing
      document.addEventListener('ap:play', (e) => {
        if (e.detail !== root && yt) yt.pauseVideo();
      });
      root.addEventListener('click', (e) => {
        const more = e.target.closest('[data-ap-more]');
        if (more) {
          const open = root.classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', String(open));
          more.textContent = open ? 'Show fewer' : more.dataset.label;
          return;
        }
        const chip = e.target.closest('[data-ap-cat]');
        if (chip) {
          const cat = chip.dataset.apCat;
          const set = chip.closest('.ap-walk__chapters');
          root.classList.toggle('is-filtered', cat !== '');
          set.querySelectorAll('[data-ap-cat]').forEach((c) => {
            c.classList.toggle('is-on', c === chip);
            c.setAttribute('aria-pressed', String(c === chip));
          });
          set.querySelectorAll('li').forEach((li) => {
            li.hidden = cat !== '' && li.dataset.cat !== cat;
          });
          return;
        }
        const pick = e.target.closest('[data-ap-video]');
        if (pick) {
          const next = pick.dataset.apVideo;
          root.querySelectorAll('[data-ap-video]').forEach((b) => {
            b.classList.toggle('is-current', b === pick);
            b.setAttribute('aria-pressed', String(b === pick));
          });
          // each video has its own chapters: show that list, fresh (no filter, not expanded)
          root.classList.remove('is-filtered', 'is-expanded');
          root.querySelectorAll('[data-chapters-for]').forEach((set) => {
            set.hidden = set.dataset.chaptersFor !== next;
            set.querySelectorAll('li').forEach((li) => (li.hidden = false));
            set.querySelectorAll('[data-ap-cat]').forEach((c) => {
              c.classList.toggle('is-on', c.dataset.apCat === '');
              c.setAttribute('aria-pressed', String(c.dataset.apCat === ''));
            });
            const more = set.querySelector('[data-ap-more]');
            if (more) {
              more.textContent = more.dataset.label;
              more.setAttribute('aria-expanded', 'false');
            }
          });
          root.querySelectorAll('.ap-walk__chapter.is-current').forEach((c) => c.classList.remove('is-current'));
          if (next !== videoId) {
            videoId = next;
            if (yt) {
              document.dispatchEvent(new CustomEvent('ap:play', { detail: root }));
              yt.loadVideoById(next);
            } else play(0);
          } else play(0);
          // the row sits under the player: bring the player into view
          if (player.getBoundingClientRect().top < 0) player.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        const btn = e.target.closest('[data-ap-start]');
        if (!btn || !id) return;
        play(parseInt(btn.dataset.apStart, 10) || 0);
        root.querySelectorAll('.ap-walk__chapter').forEach((c) => c.classList.toggle('is-current', c === btn));
      });
    };
    const boot = () => document.querySelectorAll('[data-ap-walk]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
